'use strict';

export const CODE_BIM_INCONNU = 'inconnu';

// Types d'espaces
export const CODE_BIM_FLAT = 'FLAT';
export const CODE_BIM_SPACE = 'SPACE';

// Types de bâtiments
export const CODE_BIM_TYPE_BATIMENT_APPARTEMENT = 'appartement'
export const CODE_BIM_TYPE_BATIMENT_IMMEUBLE_LOGEMENT = 'immeuble_logement'
export const CODE_BIM_TYPE_BATIMENT_MAISON_INDIVIDUELLE = 'maison_individuelle'
export const CODES_BIM_TYPES_BATIMENT_LOGEMENT = [
    CODE_BIM_TYPE_BATIMENT_APPARTEMENT,
    CODE_BIM_TYPE_BATIMENT_IMMEUBLE_LOGEMENT,
    CODE_BIM_TYPE_BATIMENT_MAISON_INDIVIDUELLE,
]

// Types de zones
export const CODE_BIM_TYPE_ZONE_LOGEMENT = 'espaces_logement'

// Paramètres du bâtiment
export const CODES_BIM_PARAMETRES_BATIMENT = {
    constructionYear: 'annee_de_construction',
    contractingAuthority: 'proprietaire',
    energyRefElec: 'numero_contrat_elec',
    energyRefFuel: 'numero_contrat_combustible',
}

// Paramètres des espaces
export const CODES_BIM_PARAMETRES_ESPACES = {
    spacePerimeter: 'perimetre',
    spaceHeight: 'hauteur_sous_plafond',
    spaceHeated: 'chauffe',
    spaceCarrezArea: 'surface_carrez_piece',
    spaceLivingArea: 'shab',
    spaceNetUsableArea: 'surface_utile_nette',
    spaceRawUsableArea: 'surface_utile_piece',
}

// Types d'ouvrages
export const CODES_BIM_OUVRAGES = {
    facing_ceiling: 'revetement_de_plafond',
    facing_floor: 'revetement_de_sol',
    facing_wall: 'revetement_de_mur',
    facing_facade: 'revetement_de_facade',
    facing_roof: 'revetement_de_toiture',
    roof: 'toit',
    slab: 'dalle',
    guardrail: 'garde_corps',
    wall: 'mur',
    stairs: 'escalier',
    column: 'poteau',
    beam: 'poutres',
    fences: 'clotures',
    opening: 'fenetre',
    roof_opening: 'fenetre_de_toit',
    door_inside: 'porte_interieure',
    door_outside: 'porte_exterieure',
    portal: 'portail',
    networks_internal: 'reseaux_interieurs',
    roadworks: 'voirie',
    courtyard: 'cours',
    footpath: 'chemin_pieton',
    lawn: 'pelouse',
    hedge: 'element_vegetal',
    skylight: 'lanterneau',
};

// Paramètres des ouvrages
export const CODES_BIM_PARAMETRES_OUVRAGES = {

    // Revêtements
    /**
     * Id BBP du mur sur lequel est posé un revêtement de mur
     */
    wall_facing: 'mur_revetement_de_mur',
    /**
     * Surface d'un revêtement
     */
    facing_surface: 'surface',
    interiorWallFacing: 'type_revetement',
    exteriorWallFacing: 'type_revetement',
    floorFacing: 'type_revetement',
    ceilingFacing: 'type_revetement',
    // Parois
    wallStructure: 'materiaux_structure',
    wallThickness: 'epaisseur',
    wallLength: 'longueur',
    wallHeight: 'hauteur',
    wallArea: 'surface',
    wallVolume: 'volume',
    wallUValue: 'coefficient_u_parois',
    wallInsulationType: 'type_isolation_paroi',
    wallInsulationWidth: 'epaisseur_isolant',
    wallInsulationWidth2: 'epaisseur_isolant_2',
    wallInsulationMaterial: 'materiaux_isolant',
    wallInsulationMaterial2: 'materiaux_isolant_2',
    wallFacing: 'parement_exterieur',
    wallLightStructure: 'parement_interieur',
    // Ouvrants
    openingThickness: 'epaisseur',
    openingHeight: 'hauteur',
    openingWidth: 'largeur',
    openingLenght: 'longueur',
    openingShift: 'decalage_menuiseries',
    openingArea: 'surface',
    openingGlazingArea: 'surface_vitree_menuiseries',
    openingFrame: 'materiau',
    openingGlaze: 'vitrage_menuiseries',
    openingGlazingGaz: 'lame_air_gaz_menuiseries',
    openingGlazingThickness: 'lame_air_epaisseur_menuiseries',
    openingOpener: 'type_ouverture_menuiseries',
    openingPanels: 'nombre_panneaux',
    openingTransom: 'imposte_menuiseries',
    openingSill: 'allege_menuiseries',
    openingClosing: 'volet_menuiseries',
    openingUw: 'uw_menuiseries',
    openingSw: 'facteur_solaire_menuiseries',
    openingTl: 'tl_menuiseries',
    // Balcons
    balconyThickness: 'largeur',
    balconyHeight: 'hauteur',
    // Poutres
    beamWidth: 'largeur',
    beamThickness: 'longueur',
    beamBBWidth: 'largeur_bb',
    beamBBLength: 'longueur_bb',
    beamBBHeight: 'hauteur_bb',
    beamMaterial: 'materiau',
    beamShape: 'forme_poutre',
    // Conduits
    pipeLength: 'longueur',
    pipeDiameter: 'diametre',
    pipeMaterial: 'materiau',
    // Escaliers
    stairHeight: 'hauteur_contre_marche_escalier',
    stairNumber: 'nombre_de_marches_escalier',
    stairDepth: 'profondeur_marche',
    stairWidth: 'largeur_de_la_marche_escalier',
    stairwayLength: 'longueur',
    stairwayWidth: 'largeur',
    stairwayHeight: 'hauteur',
    stairwayArea: 'surface',
    // Toiture
    roofArea: 'surface',
    roofThickness: 'epaisseur',
    // Équipements
    objectBBHeight: 'hauteur_bb',
    objectBBWidth: 'largeur_bb',
    objectBBLength: 'longueur_bb',
    // Bâti
    building_color: 'couleur',
    slabThickness: 'epaisseur',
    slabWidth: 'largeur',
    slabLength: 'longueur',
    slabArea: 'surface',
    slabVolume: 'volume',
    // Clôtures
    fenceLength: 'longueur',
    fenceThickness: 'epaisseur',
    fenceHeight: 'hauteur',
    fenceArea: 'surface',
    fenceRailingHeight: 'hauteur_grille_cloture',
    // Portails
    gateThickness: 'epaisseur',
    gateWidth: 'largeur',
    gateHeight: 'hauteur',
    // Espaces extérieurs
    outsideSpaceFacing: 'revetement_voirie_et_amenagements_exterieurs',
    outsideSpaceArea: 'surface',
    outsideSpacePerimeter: 'perimetre',
}

// Énumérations de valeurs pour les paramètres des ouvrages
export const ENUMS_PARAMETRES_OUVRAGES = {
    interiorWallFacingTypes: {
        concrete: 'Brut',
        brick: 'Brut',
        paint: 'Peinture',
        plaster: 'Enduit',
        wallpaper: 'Papier peint',
        fibreglass: 'Papier peint',
        fabric: 'Tissus',
        wall_tiles: 'Carrelage',
        wood_wall: 'Lambris',
        carpet: 'Moquette'
    },
    exteriorWallFacingTypes: {
        concrete: 'Brut',
        brick: 'Brut',
        paint: 'Enduit',
        wood_facade: 'Bardage bois',
        pvc_facade: 'Bardage composite',
        alu_facade: 'Bardage métal',
        stone: 'Pierre',
        cladding: 'Plaquettes parement'
    },
    floorFacingTypes: {
        concrete: 'Brut',
        polished_concrete: 'Béton',
        tiles: 'Carrelage',
        wood: 'Parquet massif',
        wood_tiles: 'Parquet flottant',
        carpet: 'Moquette',
        vinyl: 'Lino'
    },
    ceilingFacingTypes: {
        concrete: 'Béton',
        paint: 'Peinture',
        wallpaper: 'Papier peint',
        fibreglass: 'Fibre de verre',
        wood_wall: 'Lambris',
        plaster: 'Enduit'
    },
    wallInsulationTypes: {
        none: 'Aucun',
        exterior: 'ITE',
        interior: 'ITI',
        divided: 'Répartie',
        integrated: 'Intégrée',
        inferior: 'Inférieure',
        superior: 'Supérieure',
    },
    wallStructures: {
        concrete: 'Béton',
        block: 'Parpaing',
        brick: 'Brique',
        stone: 'Pierre',
        wood: 'Bois',
        steel: 'Acier',
    },
    wallInsulators: {
        none: 'Aucun',
        insulator: 'Isolant minéral',
        wood_fiber: 'Isolant végétal',
        styrofoam: 'Isolant synthétique',
        air_layer: 'Lame d\'air',
    },
    wallFacings: {
        cement: 'Enduit',
        tiles: 'Bardage',
        roof_tiles: 'Tuiles',
        stone_tiles: 'Ardoise',
        wood_tiles: 'Bois',
        ventilated_tiles: 'Bardage ventilé',
    },
    wallLightStructures: {
        gypsum: 'Plâtre'
    },
    openingFrames: {
        alu: 'Aluminium',
        pvc: 'PVC',
        wood: 'Bois',
        steel: 'Acier'
    },
    openingGlazings: {
        single: 'Simple',
        double: 'Double standard',
        triple: 'Triple'
    },
    openingTypes: {
        sliding: 'Coulissante',
        french: 'Battante',
        vertical: 'A guillotine'
    },
    openingTransoms: {
        none: 'Aucun',
        rectangle: 'Rectangulaire',
        round: 'Arrondi',
        triangle: 'Triangulaire'
    },
    openingSills: {
        none: 'Aucun',
        glazed: 'Vitrée',
        opaque: 'Opaque'
    },
    openingClosings: {
        none: 'Aucune',
        rolling: 'Roulant',
        swing: 'Battant',
        blind: 'Store'
    },
    beamMaterials: {
        concrete: 'béton',
        wood: 'bois',
        steel: 'métal'
    },
    beamShapes: {
        rectangle: 'Rectangulaire',
        circle: 'Circulaire'
    },
    pipeMaterials: {
        pvc: 'PVC',
        copper: 'Cuivre',
        per: 'PER',
        other: 'Autre',
    },
    outsideSpaceFacings: {
        asphalt: 'Asphalte',
        concrete: 'Béton',
        gravel: 'Gravier',
        lawn: 'Pelouse',
        marble: 'Dallage',
        pavement: 'Pavement',
    }
}

// Types de datasets
export const CODE_BIM_OBSERVATION = 'observation'
export const CODE_BIM_COMMENTAIRE = 'commentaire'
export const CODE_BIM_ANOMALIE = 'anomalie'
export const CODE_BIM_PRELEVEMENT_AMIANTE = 'diagnostic_action_amiante'

// Paramètres des datasets
export const CODES_BIM_PARAMETRES_DATASET_COMMENTAIRE = {
    libelle: 'commentaire',
    groupe: 'groupe',
}

export const CODES_BIM_PARAMETRES_PRELEVEMENT_AMIANTE = {
    type_conclusion: 'type_conclusion',
}
